export const LOCALE_SITE_LIST = {
  'en': ['google'],
  'zh-hans': ['amap', 'google'],
}